import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgModule } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { AppComponent } from '@app/app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '@environments/environment';

import { NbMomentDateModule } from '@nebular/moment';
import { AppRoutingModule } from '@app/app-routing.module';
import { CoreModule } from '@core/core.module';
import { ThemeModule } from '@core/theme.module';
import { TemplateCoreModule } from '@core/template-core.module';
// import { ToasterModule } from 'angular2-toaster';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';

// import { SocialLoginModule, SocialAuthServiceConfig, GoogleLoginProvider } from "@abacritt/angularx-social-login";

import { Global } from '@models/global';
import { NbThemeModule, NbLayoutModule } from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';

import { PrivacyStatementComponent } from './privacy-statement/privacy-statement.component';
import { FullWidthImageDialogComponent } from './shared/components/full-width-image-dialog/full-width-image-dialog.component';
@NgModule({
  declarations: [
    AppComponent,
    PrivacyStatementComponent,
    FullWidthImageDialogComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    // ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
    AppRoutingModule,
    CoreModule,
    ThemeModule.forRoot(),
    TemplateCoreModule.forRoot(),
    ToastrModule.forRoot({
      closeButton: true,
      positionClass: 'toast-top-center'
    }), 
    // ToasterModule.forRoot(),
    NgbModule,
    NbEvaIconsModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
    NbThemeModule.forRoot({ name: 'default' }),
    NbLayoutModule,
    NbMomentDateModule
  ],
  providers: [
    {
        provide: APP_BASE_HREF,
        useValue: '/web/'
    },
    Global
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
